import { Badge, Button, Dropdown, Icon, Menu, Select, Spin, Tabs, Tag, Tooltip } from 'antd';
import * as LogRocket from 'logrocket';
import * as React from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import {
  changeSelection,
  getAllInquiriesApplyFilter,
  getAllInquiriesResetFilter,
  getAllInquiriesResetPagination,
  getAllInquiriesSetFilter,
  getAllInquiriesSetPagination,
  setPrevPagination,
} from 'src/actions/inquiryShipperActions';
import { getInquiryMISReport, searchInquiryForShipperApi } from 'src/api/inquiry';
import LightHouseIcon from 'src/components/common/icons/LightHouseIcon';
import SortIcon from 'src/components/common/icons/SortIcon';
import Loader from 'src/components/common/Loader';
import SimplePaginator from 'src/components/common/SimplePaginator';
import withAuthAccessExim from 'src/components/hoc/withAuthAccessExim';
import { MIN_WIDTH } from 'src/globals';
import { getCreateInquiryRoute, getInquiryShipperRoute } from 'src/routing/utils';
import { INQUIRY_SHIPPER } from 'src/utils/partsToShow/partsConstants';
import InquiryShipperCard from './Cards/InquiryShipperCard';
import { INQUIRY_AUTO_REFRESH_INTERVAL_SHIPPER, searchTypeMap } from './constants';
import withInquiryMasterData from './hoc/InitInquiryMaster';
import InquiryShipperFilterPopup from './Popups/InquiryShipperFilterPopup';
import InquiryShipperSortPopup from './Popups/InquiryShipperSortPopup';
// import SEShipmentCard from './ShipmentExecution/SEShipmentCard';
import * as axios from 'axios';
import BulkInquiryUpload from 'src/components/pages/Enquiry/Modals/BulkInquiryUpload';
import { isValidArray } from 'src/Library/Helper';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import BulkRequestProgressPopup from '../../common/BulkRequestProgressPopup';
import MISReportView from '../../common/MISReportView';
import { REQUEST_STATUS } from '../BulkRequest/BulkRequestUtils';
import UpdateBulkInquiry from './Cards/UpdateBulkInquiry';
import InquiryModes from './InquiryModes';
import UploadBidsFilterModal from './Modals/UploadBidsFilterModal';
import { tokens } from 'src/design-system';


const styles = (theme: any) => ({
  outerBox: {
    display: 'flex',
    flexDirection: 'column',
    padding: '13px 24px',
    paddingBottom: '0px',
    '& .ant-btn-primary': {
      boxShadow: '0 0 0 0 rgba(0, 0, 0, 0) !important',
      textShadow: '0 0 0 0 rgba(0, 0, 0, 0) !important',
    },
  },
  innerBox: {
    display: 'flex',
  },
  toolbarWhite: {
    width: '100%',
    display: 'flex',
    background: tokens.colors.bgWhite,
    paddingTop: '12px',
    paddingBottom: '1px',
    marginBottom: 2,
    justifyContent: 'space-between',
    border: '1px solid #D9D9D9',
    borderTop: 'none',
    borderRadius: `${tokens.radius.md}px`,
    borderTopLeftRadius: '0px',
  },
  selectSearchStyle: {
    cursor: '',
    width: '124px',
    marginLeft: '15px',
    fontSize: '13px',
    '& .ant-select-selection': {
      borderRadius: '4px 0 0 4px',
    },
  },
  search: {
    '& .ant-select-selection--multiple .ant-select-selection__clear': {
      marginRight: '10px',
      borderRadius: '0 4px 4px 0',
      height: '100%',
      overflowY: 'scroll',
    },
    width: '158px',
    height: '30px',
    '& .ant-select-selection__placeholder': {
      fontSize: '13px !important',
    },
  },
  innerToolBarWhite: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    background: tokens.colors.bgWhite,
  },
  typeStyle: {
    borderRadius: '0',
    borderColor: '#d9d9d9',
    color: null,
  },
  typeFilterSelected: {
    color: tokens.colors.primary,
    borderRadius: '0',
  },
  bottomButtons: {
    bottom: 30,
  },
  notFound: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  errorBlock: {
    margin: '15px',
  },
  rightHeaderButton: {
    background: 'transparent',
    border: '1px solid #1890FF',
    color: tokens.colors.primary,
    borderRadius: `${tokens.radius.md}px`,
    marginRight: '10px',
    '&:hover': {
      background: 'transparent',
      border: '1px solid #1890FF',
      color: tokens.colors.primary,
    },
    '&:focus': {
      background: 'transparent',
      border: '1px solid #1890FF',
      color: tokens.colors.primary,
    },
  },
});

const status = [
  {
    data_key: 'all',
    label: 'All',
    color: '#030852',
  },
  {
    data_key: 'open',
    label: 'Open',
    color: '#096dd9',
  },
  {
    data_key: 'closed',
    label: 'Closed',
    color: '#cf1322',
  },
  {
    data_key: 'confirmed',
    label: 'Confirmed',
    color: '#52c41a',
  },
];

interface State {
  typeFilter: string,
  isSearching: boolean,
  popupVisible: boolean,
  sortVisible: boolean,
  clearVisible: boolean,
  dropdown: Array<any>,
  isToggle: boolean,
  isBulkUploadVisible: boolean,
  isUploadBidsFilterVisible: boolean,
  uploadRequest: undefined | {
    fileName: string,
    id: string | number,
    status: REQUEST_STATUS,
  },
}

class RFQEnquiryShipper extends React.PureComponent<any, State> {

  currentRequestId = 0;

  currentCancelToken: {
    cancel: (message: string) => void;
    token: any;
  } | null = null;

  state: State = {
    typeFilter: 'ALL',
    isSearching: true,
    popupVisible: false,
    sortVisible: false,
    clearVisible: false,
    dropdown: [] as any[],
    isToggle: false,
    isBulkUploadVisible: false,
    isUploadBidsFilterVisible: false,
    uploadRequest: undefined,
  };

  // interval for handling auto Refresh
  interval: NodeJS.Timeout;

  componentDidMount() {
    const {
      location,
      getAllInquiriesSetFilter,
      appliedFilters,
      getAllInquiriesResetFilter,
      shouldResetFilters,
    } = this.props;
    LogRocket.track('Inquiry');
    const searchArray = location?.search?.replace('?modeList=', '');
    if (searchArray) {
      getAllInquiriesSetFilter({ modeList: searchArray?.toUpperCase()?.split(',') }, true);
    } else if (!searchArray && isValidArray(appliedFilters?.modeList)) {
      shouldResetFilters && getAllInquiriesResetFilter(false);
      this.props.getAllInquiriesSetFilter({ modeList: [] }, true);
    } else if (!appliedFilters.status) {
      shouldResetFilters ? getAllInquiriesResetFilter() : this.handleReload();
    } else {
      shouldResetFilters && getAllInquiriesResetFilter(false);
      this.setStatusFilter({
        status: appliedFilters.status,
        modeList: [],
      });
    }
    this.interval = setInterval(() => this.props.setPrevPagination(), INQUIRY_AUTO_REFRESH_INTERVAL_SHIPPER);
  }

  componentWillUnmount(){
    clearInterval(this.interval);
  }

  setStatusFilter = (filters) => {
    this.props.changeSelection({});
    this.props.getAllInquiriesSetFilter(filters);
    this.props.getAllInquiriesApplyFilter();
  };

  popupFunc = (popup) => {
    if (popup === true) {
      return (
        <InquiryShipperFilterPopup
          loading={this.props.isLoading}
          closeFilter={this.closeFilter}
          handleCancel={this.handleCancel}
          handleApply={this.handleApply}
        />
      );
    }
    return <div></div>;
  };

  handleReload = () => {
    this.props.setPrevPagination();
    this.closeFilter();
  };

  handleApply = () => {
    this.props.getAllInquiriesApplyFilter();
    this.setState({
      popupVisible: false,
    });
  };

  closeFilter = () => {
    this.setState({
      popupVisible: false,
      sortVisible: false,
    });
  };

  handleCancel = () => {
    this.props.getAllInquiriesSetFilter({
      polList: this.props.appliedFilters.polList || [],
      podList: this.props.appliedFilters.podList || [],
      typeList: this.props.appliedFilters.typeList || [],
      modeList: this.props.appliedFilters.modeList,
    });
    this.setState({
      popupVisible: false,
    });
  };

  handlePrevClick = (step) => {
    this.props.getAllInquiriesSetPagination({
      currentPageNumber: this.props.pagination.currentPageNumber,
      lastInquiryId: this.props.pagination.lastItemIdPrev,
      lastSortedColumnValue: this.props.pagination.lastSortedColumnValuePrev,
      nextOrPrev: 'prev',
    });
  };

  handleNextClick = (step) => {
    this.props.getAllInquiriesSetPagination({
      currentPageNumber: this.props.pagination.currentPageNumber,
      lastInquiryId: this.props.pagination.lastItemIdNext,
      lastSortedColumnValue: this.props.pagination.lastSortedColumnValueNext,
      nextOrPrev: 'next',
    });
  };

  handleFirstPageClick = () => {
    this.props.getAllInquiriesResetPagination();
  };

  handleFilterClick = () => {
    this.props.getAllInquiriesSetFilter({
      polList: this.props.appliedFilters.polList || [],
      podList: this.props.appliedFilters.podList || [],
      typeList: this.props.appliedFilters.typeList || [],
    });
    this.setState({
      popupVisible: !this.state.popupVisible,
      sortVisible: false,
    });
  };

  handleSortClick = () => {
    this.setState({
      sortVisible: !this.state.sortVisible,
      popupVisible: false,
    });
  };

  searchInquiry = async (search) => {
    this.currentRequestId += 1;
    const requestId = this.currentRequestId;
  
    if (this.currentCancelToken) {
      this.currentCancelToken.cancel('Operation canceled due to new request.');
    }

    this.currentCancelToken = axios.default.CancelToken.source();
    
    if (!this.state.isSearching) {
      this.setState({
        isSearching: true,
      });
    }
    const response: any = await searchInquiryForShipperApi({
      inquiryString: search ? search.trim() : search,
    }, this.currentCancelToken);

    if (requestId === this.currentRequestId) {
      if (response.isSuccess) {
        this.setState({
          isSearching: false,
          dropdown: response.response,
        });
      }
    }
  };

  timeout: any = null;

  handleInquirySearch = (val) => {
    // if (val.length) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.setState({
      isSearching: true,
    });
    this.timeout = setTimeout(() => {
      this.searchInquiry(val || '');
    }, 300);
    /*} else {
      this.timeout && clearTimeout(this.timeout);
      this.setState({ dropdown: [] });
    }*/
  };

  handleToggleView = (val) => {
    sendEvent(EventCategories.INQUIRY_REPORTS, 'Inquiry Reports Page');
    this.setState({
      isToggle: val,
    });
  };

  clearFilters = () => {
    this.props.getAllInquiriesResetFilter();
    this.setState({
      popupVisible: false,
    });
  };

  handleInquiryChange = (search, option) => {
    const {
      getAllInquiriesApplyFilter,
      getAllInquiriesSetFilter,
      getAllInquiriesResetFilter,
    } = this.props;
    const { dropdown } = this.state;
    let searchType: any = '';
    if (search !== undefined) {
      dropdown.map((item) => {
        if (item.id === search.key && item.referenceNumber === search.label) {
          searchType = item.searchType;
        }
      });
      if (searchType !== 'INTERNAL_REFERENCE_NUMBER') {
        getAllInquiriesSetFilter({
          inquiryIdList: search ? [search.key] : [],
          inquirySearched: search || [],
        });
        getAllInquiriesApplyFilter();
      } else {
        getAllInquiriesSetFilter({
          internalReferenceNumberList: search ? [search] : [],
        });
        getAllInquiriesApplyFilter();
      }
    } else {
      getAllInquiriesResetFilter();
      getAllInquiriesApplyFilter();
    }
  };

  renderNoData = () => {
    const { classes, theme } = this.props;
    return (
      <div className={classes.notFound}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: '8%',
          }}
        >
          <div className={classes.notFoundItems}>
            <LightHouseIcon className={classes.blackIcon} width="184" height="184"></LightHouseIcon>
          </div>
          <div className={classes.notFoundItems} style={{ fontWeight: tokens.fontWeight.semibold, fontSize: 16 }}>
            No Inquiries to show.
          </div>
          <div className={classes.notFoundItems} style={{ paddingTop: 10, fontSize: 14 }}>
            To get more results,{' '}
            <span
              onClick={() => this.props.history.push(getCreateInquiryRoute(), 'shipper')}
              style={{
                color: theme.primaryColor,
                cursor: 'pointer',
              }}
            >
              create an inquiry
            </span>{' '}
            or try adjusting your filters.
          </div>
        </div>
      </div>
    );
  };

  FilterToolbar = (props: any) => {
    const {
      classes,
      getAllInquiriesSetPagination,
      isLoading,
      pagination,
      appliedFilters,
      totalCnt,
      modules
    } = props;
    const { isSearching, dropdown, clearVisible } = this.state;

    return (
      <div className={classes.toolbarWhite}>
        <div
          style={{
            display: 'flex',
            marginTop: '8px',
            flexDirection: 'row',
            paddingLeft: 16,
          }}
        >
          <div style={{ display: 'flex', marginTop: '-6px' }}>
            <Tooltip title="Search Inquiry or Internal Number">
              <Select
                showSearch
                allowClear
                labelInValue
                dropdownMatchSelectWidth={false}
                defaultActiveFirstOption={false}
                filterOption={(inputValue, option) => true}
                notFoundContent={
                  isSearching ? (
                    <div style={{ padding: '25px' }}>
                      <Spin style={{ marginLeft: '45%' }} />
                    </div>
                  ) : (
                    'Not Found'
                  )
                }
                suffixIcon={<Icon type="search" />}
                className={classes.search}
                placeholder={'Search'}
                onFocus={() => this.searchInquiry('')}
                value={appliedFilters.inquirySearched}
                onChange={this.handleInquiryChange}
                onSearch={this.handleInquirySearch}
                dropdownMenuStyle={{ width: '275px' }}
                optionLabelProp={'data-value'}
              >
                {dropdown &&
                  dropdown.map((item: any) => (
                    <Select.Option key={item.id} data-value={item.referenceNumber}>
                      <div style={{ display: 'flex' }}>
                        <div
                          style={{
                            width: '70%',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {item.referenceNumber}
                        </div>
                        <div style={{ width: '30%' }}>
                          <Tag
                            color={
                              item.searchType === 'INTERNAL_REFERENCE_NUMBER' ? 'purple' : 'cyan'
                            }
                          >
                            {searchTypeMap[item.searchType]}
                          </Tag>
                        </div>
                      </div>
                    </Select.Option>
                  ))}
              </Select>
            </Tooltip>
          </div>
          <InquiryModes
            appliedFilters={this.props.appliedFilters}
            modules={modules}
            setFilter={(modeList) => {
              this.props.changeSelection({});
              this.props.getAllInquiriesSetFilter({ modeList });
              this.props.history.push(
                getInquiryShipperRoute(isValidArray(modeList) ? `modeList=${modeList}` : '')
              );
            }}
            disableDomestic={false}
          />
          <div
            style={{
              marginLeft: '15px',
              width: '91px',
              height: '37px',
              cursor: 'pointer',
              display: 'flex',
              marginTop: '-1px',
            }}
            onClick={this.handleFilterClick}
          >
            <Icon
              type="filter"
              style={{
                height: '14px',
                width: '14px',
                marginTop: '3px',
                color: totalCnt === 0 ? '#424242' : tokens.colors.primary,
              }}
              theme={totalCnt ? 'filled' : 'outlined'}
            />
            <span
              style={{
                fontFamily: 'Open Sans',
                paddingLeft: '10px',
              }}
            >
              Filters
            </span>
            {totalCnt > 0 ? (
              <span style={{ marginLeft: '8px', fontWeight: 600 }}>({totalCnt})</span>
            ) : (
              <span></span>
            )}
          </div>
          <div
            style={{
              marginLeft: '20px',
              display: 'flex',
              width: '135px',
              height: '37px',
              cursor: 'pointer',
              marginTop: '-2px',
            }}
            onClick={this.handleSortClick}
          >
            <SortIcon
              style={{
                height: '14px',
                width: '14px',
                marginTop: '5px',
              }}
            />
            <span
              style={{
                fontFamily: 'Open Sans',
                paddingLeft: '10px',
              }}
            >
              Sort By
            </span>
          </div>
          {clearVisible && !isLoading ? (
            <div
              style={{
                width: '25%',
                height: '37px',
                display: 'flex',
                marginLeft: '32px',
                cursor: 'pointer',
              }}
              onClick={this.clearFilters}
            >
              <span
                style={{
                  color: tokens.colors.primary,
                  cursor: 'pointer',
                  fontWeight: tokens.fontWeight.semibold,
                }}
              >
                Clear Filters
              </span>
            </div>
          ) : (
            <div />
          )}
        </div>
        <div
          style={{
            marginTop: '2px',
            display: 'flex',
            flexDirection: 'row',
            marginRight: '2%',
          }}
        >
          <div
            style={{
              display: 'flex',
            }}
          >
            <Tooltip title="Reload">
              <Button icon="reload" disabled={isLoading} onClick={this.handleReload}></Button>
            </Tooltip>
          </div>
          <div style={{ display: 'flex', marginLeft: '7%' }}>
            <SimplePaginator
              loading={isLoading}
              isNext={pagination.isNextPresent ? pagination.isNextPresent : false}
              onFirstClick={this.handleFirstPageClick}
              onPrevClick={() => this.handlePrevClick('prev')}
              onNextClick={() => this.handleNextClick('next')}
              pageNumber={pagination.currentPageNumber}
            />
            <div style={{ margin: '0px 16px' }}>
              <Select
                value={`${pagination.resultPerPage} / page`}
                disabled={isLoading}
                onChange={(resultPerPage) => {
                  if (resultPerPage !== pagination.resultPerPage) {
                    getAllInquiriesSetPagination({ resultPerPage });
                  }
                }}
              >
                <Select.Option key={'10'}> 10 / page</Select.Option>
                <Select.Option key={'25'}> 25 / page</Select.Option>
                <Select.Option key={'50'}> 50 / page</Select.Option>
                <Select.Option key={'100'}>100 / page</Select.Option>
              </Select>
            </div>
          </div>
        </div>
      </div>
    );
  };

  newInquiryMenu = () => (
    <Menu>
      <Menu.Item
        onClick={() => {
          sendEvent(EventCategories.INQUIRY_CREATION, 'New Inquiry');
          this.props.history.push(getCreateInquiryRoute(), 'shipper');
        }}
      >
        Single Inquiry
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          sendEvent(EventCategories.INQUIRY_CREATION, 'Bulk Upload');
          this.setState({
            isBulkUploadVisible: true,
          });
        }}
      >
        Bulk Upload
      </Menu.Item>
    </Menu>
  );

  newInquiryButton = () => {
    const {
      permissions,
      showInquiryBulkUpload,
      organisationSize,
      inquiryCreationFromProcure,
    } = this.props;
    const { INQUIRY_CREATE_UPDATE_ACTIONS } = permissions;
    if (!INQUIRY_CREATE_UPDATE_ACTIONS || !inquiryCreationFromProcure)
      return;

    return (
      <Dropdown
        overlay={this.newInquiryMenu}
        overlayStyle={showInquiryBulkUpload ? undefined : { display: 'none' }}
        placement="bottomCenter"
      >
        <Button
          type="primary"
          style={{
            backgroundColor: tokens.colors.primary,
            border: tokens.colors.primary,
            borderRadius: `${tokens.radius.md}px`,
            textShadow: 'none',
          }}
          onClick={() => {
            if (!showInquiryBulkUpload) {
              sendEvent(
                EventCategories.INQUIRY_CREATION,
                'New Inquiry',
                'show inquiry bulk upload flag is false'
              );
              this.props.history.push(getCreateInquiryRoute(), 'shipper');
            }
          }}
        >
          New Inquiry
        </Button>
      </Dropdown>
    );
  };

  bulkProgressPopupNewRequestUpdate(params:{
    fileName: string,
    id: string | number,
    status: REQUEST_STATUS,
  }){
    this.setState({
      uploadRequest: params
    })
  }

  renderBulkActions = () =>{
    return (
      <UpdateBulkInquiry
      />
    )
  }

  render() {
    const defaultSortBy = {
      status: 'ALL',
      sortBy: 'created_at',
      descendingOrder: true,
    };
    const {
      classes,
      isLoading,
      data,
      appliedFilters,
      statusWiseInquiryCount,
      showBidBulkUpload,
      permissions,
    } = this.props;
    const { popupVisible, sortVisible, isBulkUploadVisible } = this.state;
    const { INQUIRY_ALL_ACTIONS, INQUIRY_VIEW_BIDS_ACTIONS } = permissions;

    const appliedFiltersArray = [
      appliedFilters.polList,
      appliedFilters.podList,
      appliedFilters.typeList,
      appliedFilters.isDraft,
      appliedFilters.isDraftIncomplete,
      appliedFilters.modeList,
      appliedFilters.destinationCountryList,
      appliedFilters.originCountryList,
      appliedFilters.internalReferenceNumberList,
      appliedFilters.accessTypeFilters,
      appliedFilters.userIdList,
      appliedFilters.originCityList,
      appliedFilters.destinationCityList,
      appliedFilters.shipperIds,
      appliedFilters.customerIds,
      appliedFilters.supplierIds,
    ]
    const totalCnt = appliedFiltersArray.reduce((acc, filter) => {
      // Filters can be an array of values or a boolean value
      if (Array.isArray(filter) && filter.length > 0) {
        return acc + 1;
      } else if (filter && !Array.isArray(filter)) {
        return acc + 1;
      }
      return acc;
    }, 0)
    
      
    const sortByOrderChanged = !(
      defaultSortBy.sortBy === appliedFilters.sortBy &&
      defaultSortBy.descendingOrder === appliedFilters.descendingOrder &&
      defaultSortBy.status === appliedFilters.status
    );
    totalCnt > 0 || sortByOrderChanged
      ? this.setState({ clearVisible: true })
      : this.setState({ clearVisible: false });
    const activeTabKey = status.findIndex((item) => {
      return item.data_key === appliedFilters.status.toLowerCase();
    });
    return (
      <div style={{ minWidth: MIN_WIDTH }}>
        {this.state.isToggle ? (
          <div className={classes.outerBox}>
            <MISReportView
              getDashboardUrl={async () => {
                const response = await getInquiryMISReport();
                return response.response.dashboardUrl;
              }}
              onBack={this.handleToggleView}
            />
          </div>
        ) : (
          <div style={{ paddingBottom: '6%' }}>
            <div className={classes.outerBox}>
              <Tabs
                type="card"
                activeKey={activeTabKey.toString()}
                tabBarGutter={-1}
                tabBarStyle={{ marginBottom: '0px' }}
                tabBarExtraContent={
                  <div style={{ display: 'flex' }}>
                    {INQUIRY_VIEW_BIDS_ACTIONS && (
                      <Button
                      className={classes.rightHeaderButton}
                      onClick={() => {
                        this.handleToggleView(true);
                      }}
                    >
                      Reports
                    </Button>
                    )}
                    {showBidBulkUpload && INQUIRY_ALL_ACTIONS && (
                      <Tooltip
                        title="Allows you to add rates on behalf of your vendors"
                        mouseEnterDelay={0.5}
                      >
                        <Button
                          className={classes.rightHeaderButton}
                          onClick={() => this.setState({ isUploadBidsFilterVisible: true })}
                        >
                          Bulk Offline Bids
                        </Button>
                      </Tooltip>
                    )}
                    {this.newInquiryButton()}
                  </div>
                }
                onChange={(key) => {
                  const element = status[parseInt(key, 10)];
                  this.setStatusFilter({ status: element.data_key.toUpperCase() });
                  this.setState({ popupVisible: false });
                }}
              >
                {status.map((element, ind) => {
                  return (
                    <Tabs.TabPane
                      disabled={isLoading}
                      tab={
                        <span style={{ display: 'flex' }}>
                          {element.label}
                          <div
                            style={{
                              color: 'white',
                              marginLeft: '7px',
                            }}
                          >
                            {!isLoading && statusWiseInquiryCount ? (
                              <Tooltip title={statusWiseInquiryCount[element.data_key]}>
                                <Badge
                                  count={statusWiseInquiryCount[element.data_key]}
                                  title=" "
                                  style={{ backgroundColor: element.color }}
                                  showZero
                                />
                              </Tooltip>
                            ) : (
                              <span className={'loadingDotsBlue'}></span>
                            )}
                          </div>
                        </span>
                      }
                      key={ind.toString()}
                    >
                      <this.FilterToolbar {...this.props} totalCnt={totalCnt} />
                    </Tabs.TabPane>
                  );
                })}
              </Tabs>

              <div style={{ position: 'relative' }}>
                {this.popupFunc(popupVisible)}
                {sortVisible ? (
                  <InquiryShipperSortPopup
                    closeFilter={this.closeFilter}
                    loading={this.props.isLoading}
                  />
                ) : (
                  <div />
                )}
              </div>
              {
                isLoading && <div style={{ height: '100%' }}>
                  <Loader style={{position: 'fixed'}} zIndex={2} backgroundColor='rgb(255, 255, 255, 0.5)'/>
                </div> 
              }
              {
                this.renderBulkActions()
              }
              <div>
                {data && data.length !== 0
                  ? data.map((el) => <InquiryShipperCard isLoading={isLoading} cardData={el} key={el.id} />)
                  : this.renderNoData()}
              </div>
            </div>
          </div>
        )}
        {isBulkUploadVisible && (
          <BulkInquiryUpload
            onModalClose={(isSuccess) => {
              this.setState({ isBulkUploadVisible: false });
              if (isSuccess) {
                this.handleReload();
              }
            }}
            isVisible={isBulkUploadVisible}
          />
        )}
        <UploadBidsFilterModal
          isShipper={true}
          visible={this.state.isUploadBidsFilterVisible}
          handleCancel={() => {
            sendEvent(EventCategories.INQUIRY_BIDDING, 'Upload Bids - Cancel');
            this.setState({ isUploadBidsFilterVisible: false });
          }}
          handleOk={() => this.setState({ isUploadBidsFilterVisible: false })}
          getRequestObject = {(request) => this.bulkProgressPopupNewRequestUpdate(request)}
        />
        <BulkRequestProgressPopup
        newRequest={this.state.uploadRequest}
        reloadShipments={() => {this.clearFilters(); this.handleReload();}}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ inquiryShipperReducer, masterData }, ownProps) => ({
  appliedFilters: inquiryShipperReducer.appliedFilters,
  selectedFilters: inquiryShipperReducer.selectedFilters,
  pagination: inquiryShipperReducer.pagination,
  isLoading: inquiryShipperReducer.isLoading,
  permissions: masterData.permissions,
  modules: masterData.modules,
  data: inquiryShipperReducer.allInquiries,
  statusWiseInquiryCount: inquiryShipperReducer.statusWiseInquiryCount,
  showInquiryBulkUpload: masterData.modules.show_inquiry_bulk_upload,
  showBidBulkUpload: masterData.modules.show_bid_bulk_upload,
  organisationSize: masterData?.userData?.organisationSize,
  inquiryCreationFromProcure: masterData?.modules?.inquiry_creation_from_procure,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllInquiriesSetFilter,
      getAllInquiriesSetPagination,
      getAllInquiriesResetPagination,
      getAllInquiriesApplyFilter,
      setPrevPagination,
      getAllInquiriesResetFilter,
      changeSelection
    },
    dispatch
  );
const RFQEnquiryShipperStyled = injectSheet(styles)(RFQEnquiryShipper);
export default withInquiryMasterData(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(withAuthAccessExim([INQUIRY_SHIPPER])(RFQEnquiryShipperStyled)))
);
